<template>
  <footer class="the-footer">
    <div class="the-footer-content">
      <contacts class="the-footer-section"></contacts>
      <quick-links class="the-footer-section"></quick-links>
      <div class="the-footer-section social-networks-logo-container">
        <social-networks></social-networks>
        <logo
          class="the-footer-logo"
          v-if="isLargeScreen"
        ></logo>
      </div>
      <logo
        class="the-footer-logo"
        v-if="!isLargeScreen"
      ></logo>
    </div>
    <div class="the-footer-copyright">
      © 2010–{{ currentYear }} «<router-link to="/">Style</router-link>»
    </div>
  </footer>
</template>

<script>
import Contacts from './the-footer/Contacts'
import Logo from './the-footer/Logo'
import SocialNetworks from './the-footer/SocialNetworks'
import QuickLinks from './the-footer/QuickLinks'
import styles from '../styles/_variables.scss'

export default {
  name: 'TheFooter',
  components: { SocialNetworks, Contacts, Logo, QuickLinks },
  data: function () {
    return {
      currentYear: new Date().getFullYear(),
      tabletBreakpoint: parseInt(styles.tabletMediaBreakpoint),
      isLargeScreen: true // dummy value, updated via js
    }
  },
  created () {
    window.addEventListener('resize', this.updateIsLargeScreen)
  },
  destroyed () {
    window.removeEventListener('resize', this.updateIsLargeScreen)
  },
  mounted () {
    this.updateIsLargeScreen()
  },
  methods: {
    updateIsLargeScreen: function () {
      this.isLargeScreen = (window.innerWidth > this.tabletBreakpoint)
    }
  }
}
</script>

<style lang="scss">
  .the-footer {
    font-family: "Gotham Pro Regular", $font-stack;
    @include media(">tablet") { font-size: 14px; };
    @include media("<=tablet") { font-size: 16px; };
    @media only print { display: none; }

    a { text-decoration: none; }
    &-heading {
      font-size: 1em;
      font-weight: normal;
      text-transform: uppercase;
      letter-spacing: 0.2em;
      color: $default-link-color;
      margin-bottom: 1em;
    }
    &-content {
      display: flex;
      flex-wrap: wrap;
    }
    &-section {
      display: flex;
      flex-direction: column;
      margin: 2.5em auto;

      @include media(">tablet") {
        flex: 1 33%;
      };
      @include media("<=tablet") {
        flex: 1 100%;
        margin-top: 0;
        &.social-networks-logo-container {
          margin-top: 2.5em;
          order: -1;
        }
      };
    }
    &-copyright { padding-bottom: 1em; }
  }

  .the-footer-logo {
    @include media("<=tablet") {
      display: flex;
      margin-top: 0 !important;
    };
  }
</style>



// WEBPACK FOOTER //
// src/components/TheFooter.vue